import { render, staticRenderFns } from "./FirmaDigital.vue?vue&type=template&id=d7013cd8"
import script from "./FirmaDigital.vue?vue&type=script&lang=js"
export * from "./FirmaDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7013cd8')) {
      api.createRecord('d7013cd8', component.options)
    } else {
      api.reload('d7013cd8', component.options)
    }
    module.hot.accept("./FirmaDigital.vue?vue&type=template&id=d7013cd8", function () {
      api.rerender('d7013cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/firmadigital/FirmaDigital.vue"
export default component.exports